import React, { Component } from "react";

class TotalMilesCalculator extends Component {
  render() {
    let prices = this.props.prices;
    let multipliers = this.props.multipliers;

    let c = function(p, m) {
      let floatPrice = parseFloat(p);
      if (floatPrice > 0) {
        return parseFloat(p * m);
      }

      return 0;
    };

    const milesBase = c(prices.base, multipliers[0]);
    const milesAf = c(prices.af, multipliers[1]);

    const bonus = parseFloat(this.props.bonus);

    let totalMiles = milesBase + milesAf;
    if (bonus > 0) {
      totalMiles += bonus;
    }

    totalMiles = Math.round(totalMiles * 100 / 100);

    if (isNaN(totalMiles) || totalMiles < 0) {
      return <div className="CellDisplay">N/A</div>;
    } else {
      return (
        <div className="CellDisplay">
          <strong>
            {totalMiles}
          </strong>
        </div>
      );
    }
  }
}

export default TotalMilesCalculator;



// WEBPACK FOOTER //
// ./src/TotalMilesCalculator.js